export class FoodUpdatePayload {
  constructor (data) {
    this.names = data.names;
    this.descriptions = data.descriptions;
    this.macroCategory = { key: data.categories.macro };
    this.microCategory = { key: data.categories.micro };
    this.prices = {
      sellingPrice: data.price
    };
    this.brand = data.brand;
  }
}
